import type { NotificationLogStatus } from "./types";

export const NOTIFICATION_LOG_STATUSES: NotificationLogStatus[] = [
  "QUEUED",
  "SENT",
  "DELIVERED",
  "FAILED",
  "DROPPED",
];

export const LOG_STATUS_COLOR: Record<NotificationLogStatus, string> = {
  QUEUED: "bg-blue-100 text-blue-800",
  SENT: "bg-sky-100 text-sky-800",
  DELIVERED: "bg-green-100 text-green-800",
  FAILED: "bg-red-100 text-red-800",
  DROPPED: "bg-gray-100 text-gray-600",
};

export const LOG_STAT_CARD_COLOR: Record<string, string> = {
  total: "text-foreground",
  queued: "text-blue-600",
  sent: "text-sky-600",
  delivered: "text-green-600",
  failed: "text-red-600",
  dropped: "text-gray-500",
};

export const NOTIFICATION_TYPES = [
  "CHALLENGE_STARTING",
  "CHALLENGE_ENDED",
  "CHALLENGE_NEW_MEMBER",
  "EVENT_REMINDER",
  "EVENT_NEW_MEMBER",
  "KOINS_MILESTONE",
  "MARKETPLACE",
  "GENERAL",
  "STREAK_UPDATES",
  "CHALLENGE_PROGRESS",
  "REMINDERS",
  "ACTIVITY_UPDATES",
  "WEEKLY_SUMMARY",
  "ORG_UPDATES",
  "SOCIAL_UPDATES",
] as const;

/**
 * i18n key per notification type — resolve with t() at the render site.
 * Backend `entry.type` values render through this map (never raw); fall back
 * to the raw value when a future type has no key yet.
 */
export const NOTIFICATION_TYPE_LABEL_KEYS: Record<string, string> = {
  CHALLENGE_STARTING: "notificationLogs.type.CHALLENGE_STARTING",
  CHALLENGE_ENDED: "notificationLogs.type.CHALLENGE_ENDED",
  CHALLENGE_NEW_MEMBER: "notificationLogs.type.CHALLENGE_NEW_MEMBER",
  EVENT_REMINDER: "notificationLogs.type.EVENT_REMINDER",
  EVENT_NEW_MEMBER: "notificationLogs.type.EVENT_NEW_MEMBER",
  KOINS_MILESTONE: "notificationLogs.type.KOINS_MILESTONE",
  MARKETPLACE: "notificationLogs.type.MARKETPLACE",
  GENERAL: "notificationLogs.type.GENERAL",
  STREAK_UPDATES: "notificationLogs.type.STREAK_UPDATES",
  CHALLENGE_PROGRESS: "notificationLogs.type.CHALLENGE_PROGRESS",
  REMINDERS: "notificationLogs.type.REMINDERS",
  ACTIVITY_UPDATES: "notificationLogs.type.ACTIVITY_UPDATES",
  WEEKLY_SUMMARY: "notificationLogs.type.WEEKLY_SUMMARY",
  ORG_UPDATES: "notificationLogs.type.ORG_UPDATES",
  SOCIAL_UPDATES: "notificationLogs.type.SOCIAL_UPDATES",
};

export const POLL_INTERVAL_MS = 30_000;
